<template>
    <div class="row align-items-stretch">
        <div
            class="col-12 col-md-3  px-0 px-md-4 px-xl-5 border-right border-bottom text-center  py-3 py-md-0 d-flex flex-row align-items-center "
            :class="{'col-md-6' : !deal.savings, ' col-md-3': deal.savings  }"
        >
            <img v-if="deal.product.supplier.image" class="ml-auto mr-auto mr-md-0 img-fluid" :src="deal.product.supplier.image" :alt="deal.product.supplier.name"
                 :title="deal.product.supplier.name">
            <span v-else class="ml-auto">{{deal.product.supplier.name}}</span>
        </div>
        <div
            class="col-12 col-md-6  px-0 px-md-4 px-xl-5  border-bottom text-center text-md-left py-3 py-md-0 d-flex flex-column justify-content-center"
        :class="{'border-right' : deal.savings }">
            <h5>{{ deal.product.title }}</h5>
            <p class="m-0">
                <span class="mr-4">{{ deal.product.rate || 'Fixed Rate contract' }}</span>
                <span>{{ deal.product.period || '12 months'}}</span>
            </p>
        </div>
        <div class="col-12 col-md-3 d-flex flex-column justify-content-center align-items-center py-3 py-md-0"
        v-if="deal.savings">
            <span class="text-success">You save</span>
            <span class="text-success h3 m-0">&pound;{{ deal.savings }}</span>
            <span class="text-success">per year</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DealSummary',
    props: {
        deal: Object
    }
}
</script>
<style scoped lang="scss">
@import "../../sass/base";

@include media-breakpoint-down(md) {
    .border-right {
        border-right: none !important;
    }
}

@include media-breakpoint-up(md) {
    .border-bottom {
        border-bottom: none !important;
    }
}
</style>
